// extracted by mini-css-extract-plugin
module.exports = {"layout":"index_layout__2Jj8d","mainLayout":"index_mainLayout__3788G"};